import { Twitter, Facebook } from 'lucide-react';
import { prefetchBestPropFirmsPage } from '../utils/prefetchBestPropFirmsPage';

export function Footer() {
  return (
    <footer className="bg-black text-yellow-100 pt-12 px-4 sm:px-6 text-sm mt-0 border-t border-yellow-800/20">
      <div className="max-w-7xl mx-auto space-y-12">
        <div className="grid gap-y-12 gap-x-8 md:grid-cols-2 lg:grid-cols-4 divide-y md:divide-y-0 divide-yellow-800/40">
          <div className="space-y-4 pt-0 md:pt-0 text-center md:text-left">
            <div className="flex items-center justify-center md:justify-start gap-2">
              <img src="/assets/logo.svg" alt="Logo" className="w-12 h-12" />
              <span className="text-yellow-400 font-bold text-lg">PropViper</span>
            </div>
            <p className="leading-relaxed text-yellow-200">
              Helping traders find the best prop firms with honest reviews, real comparisons, and exclusive promo codes.
            </p>
          </div>

          <div className="space-y-4 pt-6 md:pt-0 text-center md:text-left">
            <h3 className="text-yellow-400 font-semibold">Quick Links</h3>
            <ul className="space-y-2">
              <li><a href="/compare" className="hover:text-yellow-400">Comparison</a></li>
              <li>
                <a
                  href="/best-prop-firms"
                  className="hover:text-yellow-400"
                  onMouseEnter={prefetchBestPropFirmsPage}
                >
                  Best Prop Firms
                </a>
              </li>
              <li><a href="/reviews" className="hover:text-yellow-400">Read Reviews</a></li>
              <li><a href="/blog" className="hover:text-yellow-400">Blog</a></li>
              <li><a href="/subscribe" className="hover:text-yellow-400">Subscribe</a></li>
              <li><a href="/about" className="hover:text-yellow-400">About Us</a></li>
            </ul>
          </div>

          <div className="space-y-4 pt-6 md:pt-0 text-center md:text-left">
            <h3 className="text-yellow-400 font-semibold">Featured Firms</h3>
            <ul className="space-y-2">
              <li><a href="/reviews/cti" className="hover:text-yellow-400">City Traders Imperium</a></li>
              <li><a href="/reviews/ttp" className="hover:text-yellow-400">The Trading Pit</a></li>
              <li><a href="/reviews/fxify" className="hover:text-yellow-400">FXIFY</a></li>
            </ul>
          </div>

          <div className="space-y-4 pt-6 md:pt-0 text-center md:text-left">
            <h3 className="text-yellow-400 font-semibold">Contact</h3>
            <ul className="space-y-2">
              <li>
                <div className="text-yellow-500 text-xs uppercase mb-1">Need help?</div>
                <a href="mailto:support@propviper.com" className="hover:text-yellow-400 font-semibold">
                  support@propviper.com
                </a>
              </li>
              <li><a href="/privacy-policy" className="hover:text-yellow-400">Privacy Policy</a></li>
              <li><a href="/terms-of-use" className="hover:text-yellow-400">Terms of Use</a></li>
              <li><a href="/changelog" className="hover:text-yellow-400">Changelog</a></li>
            </ul>
          </div>
        </div>

        <div className="flex justify-center gap-4 pt-2">
          <a
            href="https://twitter.com/thepropviper"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-yellow-400 hover:text-yellow-300 transition text-sm"
          >
            <Twitter className="w-5 h-5" />
            @thepropviper
          </a>
          <a
            href="https://www.facebook.com/propviper"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-yellow-400 hover:text-yellow-300 transition text-sm"
          >
            <Facebook className="w-5 h-5" />
            PropViper
          </a>
        </div>

        <div className="border-t border-yellow-800 pt-6 text-center text-yellow-600 text-xs">
          Built by traders, for traders. <br />
          &copy; {new Date().getFullYear()} PropViper. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
